/* eslint-disable max-len */
import { MantineProvider } from "@mantine/core";
import '@mantine/dates/styles.css';
import { QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { init, BrowserTracing, Replay } from "@sentry/react";
import { createRoot } from "react-dom/client";
import { queryClient } from "./hooks/QueryHooks";
import "./tailwind.css";
import theme from "./theme/theme";
import Main from "./main";

// Load Hyperengage SDK script with env vars
(() => {
  const trackingHost = import.meta.env.VITE_TRACKING_HOST;
  const workspaceKey = import.meta.env.VITE_HE_WORKSPACE_KEY;
  const dataKey = import.meta.env.VITE_HE_DATA_KEY;
  if (trackingHost && workspaceKey && dataKey) {
    const s = document.createElement("script");
    s.src = "https://unpkg.com/@hyperengage/sdk-js@1.0.3/dist/web/lib.js";
    s.integrity = "sha384-vCL0uNNV1mdyiRnWlShXUhWL7FdTtDhuOTP7FXggl5RdZzzwW9/zA8wH0UZ7n1dv";
    s.crossOrigin = "anonymous";
    s.defer = true;
    s.dataset.trackingHost = trackingHost;
    s.dataset.workspaceKey = workspaceKey;
    s.dataset.key = dataKey;
    s.dataset.initOnly = "true";
    document.head.appendChild(s);
  }
})();

if (import.meta.env.VITE_ENV === "production" || import.meta.env.VITE_ENV === "staging") {
  init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    integrations: [
      new BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/staging\.hyperengage\.io/],
      }),
      new Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const root = createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme}>
        <Main />
      </MantineProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
